import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { SessionActions } from "../actions/guideStreamActions";

export default function activeMentorReducer(state = initialState.activeMentors, action: SessionActions) {
    switch (action.type) {
        case types.LOAD_ACTIVE_MENTORS_SUCCESS:
            return action.activeMentors;
        default:
            return state;
    }
}
